import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button, ButtonGroup} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

export default class WosWorked extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_WOS_WORKED';
		this.state.filterDate = moment().day(0)
	}

	fetchData = async () => {
		this.state.limit = 50;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterDate = this.state.filterDate;
		this.state.filter.user = this.props.user ?? null;
		this.model.filter = this.state.filter;
		this.model.filter.manager = this.props.managerView;
		this.model.filter.user = this.props.user;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual();
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Engineer",
				id: "field_engineer_name",
				accessor: obj => obj.field_engineer_name
			},
			{
				Header: "Work Orders Completed",
				id: "counting",
				accessor: obj => obj.counting,
			},
			{
				Header: "Est Days Worked",
				id: "days_worked",
				accessor: obj => (obj.counting ?? 0) / (obj.fe_work_order_amount ?? 4),
			}
		]

		const startDate = this.state.filterDate ? moment(this.state.filterDate) : moment().day(0);
		const endDate = this.state.filterDate ? moment(this.state.filterDate).add(6, 'days') : moment().day(0).add(6, 'days');

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className={"row rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(7, 'days').format()}, async () => {
										await this.fetchData();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({filterDate: moment().day(0)}, async () => {
										await this.fetchData();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(7, 'days').format()}, async () => {
										await this.fetchData();
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={"rbc-toolbar-label"}>
								<label>
									{startDate.format('MMMM D') + ' - ' + endDate.format('MMMM D')}
								</label>
							</div>
							<Button onClick={async () => {
								await this.fetchData();
							}} size={"sm"} color="primary">
								<i className="fa fa-users"/>Refresh Data
							</Button>
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
